$('.hero__case-studies-wrapper').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear',
    mobileFirst: true,
    dots: true,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                dots: false
            }
        }
    ]
});

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.scrolling-message__inner');
    if (!container) return;
    const content = Array.from(container.children);
    const viewportWidth = window.innerWidth * 2;
    let contentWidth = container.scrollWidth;
    
    while (contentWidth < viewportWidth) {
        content.forEach(item => {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            container.appendChild(clone);
        })
        contentWidth = container.scrollWidth;
    }
});


if (window.innerWidth < 992) {
    let modalOpen;
    let lpCtaContactClose;
    const lpMobileCta = document.getElementById('lpMobileCta');
    const lpCtaContact = document.querySelector('#modal[data-model="lpCtaContact"]');

    if(lpMobileCta){
        modalOpen = lpMobileCta.querySelector('[data-toggle="modal"]');
    }
    if(lpCtaContact){
        lpCtaContactClose = lpCtaContact.querySelector('[data-dismiss="modal"]');
    }

    window.addEventListener('scroll', () => {
        const footer = document.querySelector('footer');
        const footerTop = footer.offsetTop;
        const windowHeight = window.innerHeight;
        const scrollY = window.scrollY;

        if (scrollY > 200) {
            lpMobileCta.classList.add('active');
        } else {
            lpMobileCta.classList.remove('active');
        }
    
        if (scrollY + windowHeight >= footerTop) {
            lpMobileCta.style.position = 'absolute';
            lpMobileCta.style.bottom = 0;
        } else {
            lpMobileCta.style.position = 'fixed';
            lpMobileCta.style.bottom = '0';
        }
    });

    // guard operator will only run if modalOpen is true
    modalOpen && modalOpen.addEventListener('click', () => {
        document.body.style.overflow = 'hidden';
        document.querySelector('header').classList.add('hidden');
        lpCtaContact.classList.remove('hidden');
    });

    lpCtaContactClose && lpCtaContactClose.addEventListener('click', () => {
        document.body.style.overflow = 'auto';
        document.querySelector('header').classList.remove('hidden');
        lpCtaContact.classList.add('hidden');
    });
}